import { useEffect, useState, useRef } from "react";
import { getMessageImage } from "~/lib/network/chat";
import { ImageInMessage } from "~/types/message";
import { FiCopy, FiCheck, FiDownload } from "react-icons/fi";
import ImageLoader from "~/components/markdown-container/markdown-components/images/image-loader";
import { copyImage, downloadImage } from "../../utils/output-image-utils";
// Using regular img tag instead of next/image for Vite

const OutputImage = ({ node, inline, className, children, ...props }: any) => {
  const { message, src } = props;
  const [image, setImage] = useState<ImageInMessage | null>(null);
  const [isCopied, setIsCopied] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);
  const downloadRef = useRef<HTMLAnchorElement>(null);

  const handleCopyImage = async () => {
    try {
      const copyStatus = await copyImage(imageRef);
      setIsCopied(copyStatus);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    } catch {
      setIsCopied(false);
    }
  };

  useEffect(() => {
    const loadImage = async () => {
      if (message) {
        try {
          const image = await getMessageImage(
            message.session_id,
            message._id,
            src
          );
          setImage(image);
        } catch (error) {
          console.error("Failed to load image:", error);
        }
      }
    };
    loadImage();
  }, []);

  if (!image) {
    return <ImageLoader />;
  }

  return (
    <>
      <div className={`flex justify-end p-1 gap-2.5 ${className || ""}`}>
        <div className="tooltip tooltip-top" data-tip="Download">
          <FiDownload
            size={20}
            className="cursor-pointer rounded p-0.5 transition-all duration-300 hover:bg-base-300"
            onClick={() => downloadImage(imageRef, downloadRef, src)}
          />
        </div>
        <a ref={downloadRef} className="hidden" />
        <div
          className="tooltip tooltip-top"
          data-tip={isCopied ? "Copied" : "Copy"}
        >
          {isCopied ? (
            <FiCheck
              size={20}
              className="cursor-pointer rounded p-0.5 transition-all duration-300"
            />
          ) : (
            <FiCopy
              size={20}
              onClick={handleCopyImage}
              className="cursor-pointer rounded p-0.5 transition-all duration-300 hover:bg-base-300"
            />
          )}
        </div>
      </div>
      <img
        ref={imageRef}
        className="rounded-lg max-w-full h-[500px] object-contain"
        key={image.file_name}
        src={image.image_data}
        alt={image.file_name}
      />
    </>
  );
};

export default OutputImage;
